import checkAuthorization from 'src/services/accessService';
import MedicationLogs from '../components/MedicationLogs';
import {action, entity} from 'src/constant/authorization';

const stackRoutes = [
  {
    name: 'Medication logs',
    path: 'medicationLogs',
    component: MedicationLogs,
    visible: user => {
      return checkAuthorization(user, entity.medicationLogs, action.view);
    },
  },
];

export default {
  stack: stackRoutes,
};
